import type { UpgradeReason } from '@/components/upgrade/upgrade-prompt.store';

/**
 * The upgrade prompt's reason for a sidebar destination that can be locked,
 * by its id (the same ids in both sidebars); null for any other.
 */
export function lockedUpgradeReason(id: string): UpgradeReason | null {
  switch (id) {
    case 'sequences':
    case 'inbox':
    case 'tasks':
      return id;
    default:
      return null;
  }
}
